// extracted by mini-css-extract-plugin
export default {"wrapper":"A_HeaderItem_wrapper__UPSjS","active":"A_HeaderItem_active__KkE29","icon_wrapper":"A_HeaderItem_icon_wrapper__Nr7Um","badge":"A_HeaderItem_badge__6OcQ6"};